import PageHandler from "./PageHandler";
import Pages from "Pages";

class ApplicationDetailPageHandler extends PageHandler {
  constructor() {
    super("application-detail", Pages.ApplicationDetailPage);
  }

  fetch(parameters) {
    let app = this.rootStore.data.ApplicationsStore.findById(parameters.id);
    if (!app) this.rootStore.data.ApplicationsStore.fetchId(parameters.id);
  }
}

export default ApplicationDetailPageHandler;



// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/ApplicationDetailPageHandler.js